import * as React from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import InlineSVG from "react-inlinesvg";
import { cn } from "src/lib/cn";
import { SudoTooltip } from "src/sudokit/components/SudoTooltip";
import { useToast } from "../components/ToastWrapper";

interface ICopyToClipboardButton {
  textToCopy: string;
  displayText?: string;
  customContent?: React.ReactNode;
  ariaLabel?: string;
  successMessage?: string;
  useIcon?: boolean;
  className?: string;
  tooltipText?: string;
  truncate?: boolean;
  iconClassName?: string;
}

export const CopyToClipboardButton: React.FC<ICopyToClipboardButton> = ({
  displayText,
  textToCopy,
  successMessage = "Copied to Clipboard",
  useIcon = false,
  className = "",
  tooltipText = "Copy",
  truncate = false,
  iconClassName,
}: ICopyToClipboardButton) => {
  const { setToast } = useToast();
  const [copied, setCopied] = React.useState(false);

  const handleCopy = () => {
    setCopied(true);
    setToast(successMessage);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <SudoTooltip
      text={copied ? "Copied" : tooltipText ?? ""}
      disabled={!tooltipText?.length}
      hasArrow={false}
    >
      <CopyToClipboard
        text={textToCopy}
        onCopy={handleCopy}
      >
        <button
          className={cn(
            "copy flex justify-center items-center gap-2 p-1 text-inherit bg-transparent rounded-md hover:bg-app-primary-cta-transparent-15 transition-colors text-gray-600 border-none cursor-pointer",
            className
          )}
          style={{ color: "inherit" }}
          aria-label={displayText}
        >
          {useIcon ? (
            <InlineSVG
              className={cn("w-5 h-5 text-gray-600", iconClassName)}
              src={"/assets/Copy.svg"}
            />
          ) : truncate ? (
            <p className="truncate">{displayText ?? textToCopy}</p>
          ) : (
            displayText ?? textToCopy
          )}
        </button>
      </CopyToClipboard>
    </SudoTooltip>
  );
};

export default CopyToClipboardButton;
